import HeatmapRender from '../components/HeatmapRender';
import { connect } from 'react-redux';
import qs from 'query-string';

const mapStateToProps = (state, ownProps) => {
  const { viewportIndex } = ownProps;
  const viewportData = state.viewports.viewportSpecificData[viewportIndex];
  const context = state.ui.heatmapContext;
  let heatmap, element;
  const params = qs.parse(window.location.search);
  const objects = params.objects ? JSON.parse(params.objects)[0] : {};
  const ObjectUid = objects.ObjectUid || ownProps.sopInstanceId;
  if (viewportData && ObjectUid) {
    heatmap = state.api.heatmaps.heatmaps.find(
      hm => hm.objectUid === ObjectUid && context.activeId === hm.type
    );
    element = viewportData.dom;
  }
  return { heatmap, element, context };
};

const ConnectedHeatmapRender = connect(mapStateToProps)(HeatmapRender);
export default ConnectedHeatmapRender;
